module.exports = __webpack_public_path__ + "static/img/fiveLast.f9bbaa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fiveLast.png
// module id = dqhO
// module chunks = 1